import { Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MatDateFormats } from '@angular/material/core';
import { safeParseDate } from '@ct/model';
import {
  endOfMonth as endOfMonthFn,
  format as formatFn,
  getTime as getTimeFn,
  isAfter as isAfterFn,
  isBefore as isBeforeFn,
  isSameDay as isSameDayFn,
  isValid,
  parse as parseFn,
  startOfMonth as startOfMonthFn,
} from 'date-fns';

export const format = (date: Date | string, dateFormat: string) => {
  if (!date || (date instanceof Date && isNaN(date.getTime()))) {
    return null;
  }
  date = typeof date === 'string' ? parse(date) : (date as Date);
  return formatFn(date, dateFormat);
};

export const getTime = (date: Date | string) => {
  return getTimeFn(checkParseDate(date));
};

export const startOfMonth = (date: Date | string) => {
  return startOfMonthFn(checkParseDate(date));
};

export const endOfMonth = (date: Date | string) => {
  return endOfMonthFn(checkParseDate(date));
};

export const isBefore = (date: Date | string, dateToCompare: Date | string) => {
  if (!date || !dateToCompare) {
    return false;
  }
  return isBeforeFn(checkParseDate(date), checkParseDate(dateToCompare));
};

export const isAfter = (date: Date | string, dateToCompare: Date | string) => {
  if (!date || !dateToCompare) {
    return false;
  }
  return isAfterFn(checkParseDate(date), checkParseDate(dateToCompare));
};

export const isSameDay = (date: Date | string, dateToCompare: Date | string) => {
  if (!date || !dateToCompare) {
    return false;
  }
  return isSameDayFn(checkParseDate(date), checkParseDate(dateToCompare));
};

const checkParseDate = (date: Date | string) => {
  date = typeof date === 'string' ? parse(date) : (date as Date);
  return date;
};

export const parse = (date: Date | string) => {
  if (date instanceof Date) return date;
  let d = safeParseDate(date);
  if (isValid(d)) {
    return d;
  }
  d = parseFn(date, 'dd-mm-yyyy', new Date());
  if (isValid(d)) {
    return d;
  }
  return null;
};

@Injectable()
export class CtDateAdapter extends DateFnsAdapter {
  createDate(year: number, month: number, date: number): Date {
    const d = super.createDate(year, month, date);
    d.setHours(12);
    return d;
  }

  parse(value: string, parseFormat: string | Array<string>): Date | null {
    const d = super.parse(value, parseFormat);
    if (d !== null) {
      d.setHours(12);
    }
    return d;
  }
}

export const DATE_FORMATTER: MatDateFormats = {
  parse: {
    dateInput: ['MMM d, yyyy', 'yyyy-MM-d', 'MM/d/yyyy'],
  },
  display: {
    dateInput: 'MMM d, yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MMM d, yyyy',
    monthYearA11yLabel: 'MMM yyyy',
  },
};
